import { CommonModule } from "@angular/common";
import { Component, computed, inject } from "@angular/core";
import { Router } from "@angular/router";
import { DocumentStore } from "../../../store/document.store";
import { DocumentSelectTicketItem } from "./document-select-ticket-item/document-select-ticket-item";
import { UserStore } from "../../../../../../stores/user.store";
import { ModalService } from "@malirang/front-share";

@Component({
    selector: "app-document-select-ticket",
    templateUrl: "./document-select-ticket.html",
    styleUrls: ["./document-select-ticket.css"],
    imports: [CommonModule, DocumentSelectTicketItem],
})
export class DocumentSelectTicket {
    readonly documentStore = inject(DocumentStore);
    readonly router = inject(Router);
    readonly userStore = inject(UserStore);
    readonly modalService = inject(ModalService);

    readRole = this.documentStore.readRole;
    ticketId = this.documentStore.ticketId;
    tickets = this.documentStore.tickets;

    filterTickets = computed(() => {
        if (this.readRole()) {
            return this.tickets();
        }

        return this.tickets().filter(
            (ticket) =>
                ticket.enrollment.teacher.userId === this.userStore.user()?.id,
        );
    });

    handleSelect(ticketId: string) {
        this.modalService.close();

        this.router.navigate([], {
            queryParams: { ticketId },
            queryParamsHandling: "merge",
        });
    }
}
